import { Button, Grid } from "@mui/material";

import MarketPrices from "./Components/MarketPrices";
import { TRADE_SIDE } from "../constants";
import TradingViewChart from "./Components/TradingViewChart";
import useIsMobileView from "hooks/useIsMobileView";
import { useSearchParams } from "react-router-dom";

function TradeChartView({
  coinMarketDetails,
  tradeInitial,
  handleShowOrHideTradingView,
}) {
  const isMobileView = useIsMobileView();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSelectSide = (side) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, sideId: side?.id });

    handleShowOrHideTradingView();
  };

  return (
    <>
      {isMobileView && <MarketPrices coinMarketDetails={coinMarketDetails} />}

      <Grid container my={2}>
        <Grid item xs={12}>
          <TradingViewChart symbol={coinMarketDetails?.coinSourceName} />
        </Grid>
      </Grid>

      {isMobileView && (
        <Grid container spacing={1}>
          {tradeInitial?.lisSide?.map((side) => (
            <Grid item xs={6}>
              <Button
                color={TRADE_SIDE[side?.name]?.color}
                fullWidth
                variant="contained"
                onClick={() => handleSelectSide(side)}
              >
                {side?.name}
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}

export default TradeChartView;
